<template>
  <div class="HomePage">
    <!-- <div id="app">
          <h1>{{ $t("message.hello") }}</h1>
          <button @click="changeLanguage('zh')">中文</button>
          <button @click="changeLanguage('ja')">日本語</button>
        </div> -->
    <div class="con_box">
      <div class="top_box">
        <div class="top_img" @click="toHome">
          <img src="../assets/logo.jpg" alt="" @click="toHome" />
        </div>
        <div class="top_rig">
          <div @click="toGaiyao" class="tab">{{ $t("home.h2") }}</div>
          <div class="tab tab1">{{ $t("home.h3") }}</div>
          <div @click="toshiji" class="tab">{{ $t("home.h4") }}</div>
          <div @click="towenxun" class="tab">{{ $t("home.h5") }}</div>
          <!-- <select v-model="selectedOption" @change="handleChange">
            <option disabled value="">请选择</option>
            <option>中文</option>
            <option>日本語</option>
          </select> -->
        </div>
      </div>
      <div class="bg_img">
        <img src="../assets/bg.png" alt="" />
      </div>

      <div class="hudong_title">{{ $t("home.h3") }}</div>
      <div class="title2">日中インターンシップ事業立ち上げ</div>
      <div class="wenan">
        当協会が推進する日中インターンシップ事業は、中国の大学、中国の大学生、日本の採用企業の三者が協力して展開される体制となっています。<br />
        <div class="hang"></div>
        インターンシップは、中国の大学と日本の公私の機関との間に契約に基づき、大学が認める「海外実習」として位置付けられています。<br />
        <div class="hang"></div>
        大学は、インターンシップ期間に応じて単位を付与することができます。ただし、実習期間中には、学生の将来性を見据えた「カリキュラム」が必要となり、これは大学の専攻内容と日本企業の事業内容の関係性を踏まえて策定されます。<br />
        <div class="hang"></div>
        在留資格については、インターンシップ期間は１年を超えない期間であり、かつ、通算して当該大学の就業年限の２分の１を超えない期間であることが必要です。<br />
        <div class="hang"></div>
        特定活動9号ビザは、外国人学生が日本でインターンシップを行うための在留資格です。このビザを取得することで、一定期間日本で働くことができます。特定活動9号ビザを申請するためには、申請者が大学に在籍していることが必要で、インターンシップ期間が決まっている必要があります。
      </div>
      <div class="j1_img j2_img">
        <img src="../assets/j1.jpg" alt="" />
      </div>
      <div class="title2">
        中国における日本インターンシップ<span class="span_te">プログラム</span>
      </div>
      <div class="wenan">
        中国大学生の日本でのインターンシッププロジェクトは、日本法務省が国際教育文化交流を推進するために海外の大学在学生に向けて、打ち出した日本への短期インターンシップ実践プロジェクトである。<br />
        <div class="hang"></div>
        社会実践は中国の高等教育の重要な構成部分でもあり、実践教育は国家の高等素質教育の需要にも合致している。教育の国際化を背景に、異文化社会の実践はすでに国際化人材育成の革新的な形式となっている。<br />
        <div class="hang"></div>
        「教育部などの部門の大学実践育人活動の更なる強化に関するいくつかの意見」の関連要求に基づき、各大学は相次いで実践育人活動を人材育成の重要な位置に置き、学校教育計画に組み入れ、教育システムを系統的に設計し、実践し、相応の時間単位を規定しました。<br />
        <div class="hang"></div>
        教育部の呼びかけに応じ、各大学及び日本語専門学生の実際の需要を満たし、中日両国の教育界の友好交流を増進するため、日本法務省が指定した日本社会実践支援機構及び企業と協力し、周期２か月から１２か月の日本企業実践プロジェクトを展開し、同時に学生が卒業後の就職先紹介にも力入れています。<br />
        <div class="hang"></div>
        大学の学生は職場での親身的な実践を通じて、日本企業の先進的な管理モデルとサービス理念を学び、企業の運営モデル、働き方、人間関係を理解することは、中国大学生が短期的に日本語のレベルを高めるだけでなく、卒業後に就職するための技能を身につけ、職場体験を蓄積し、社会進出のための土台を作り、人生設計をより計画的に定めるのにも役立ちます。<br />
      </div>
      <div class="j1_img">
        <img src="../assets/j2.png" alt="" />
      </div>
      <div class="j1_img">
        <img src="../assets/j4.png" alt="" />
      </div>
      <div class="wenan wenan1">
        日中国際教育交流協会設立以来、中国国内の多くの大学と提携関係を結んでおります。<span
          class="span_te"
        >
          <div class="hang1"></div>
          北京第二外国語学院、四川外国語大学、雲南師範大学、貴州大学、広西大学、海南大学、寧夏大学、雲南大学をはじめとする中国国内68の大学と深い連携を結んでまいりました。</span
        >
        <div class="hang1"></div>
        これまでに延べ831名の学生に日本でのインターンシップ機会を提供し、その間、「安全事故ゼロ・苦情ゼロ」という『ダブルゼロ』の記録を達成してきました。
      </div>
      <div class="hang"></div>
      <div class="j1_img">
        <img src="../assets/j1.png" alt="" />
      </div>
      <!-- <div class="wenan">
        {{ $t("jie.j2") }}
      </div>
      <div class="wenan">
        {{ $t("jie.j3") }}
      </div> -->

      <div class="footer">
        <div class="foo_con">
          <div class="fo_le">
            <img src="../assets/logo2.png" alt="" />
            <div class="fo_le_re">
              <div class="fo_top">{{ $t("home.h23") }}</div>
              <div class="fo_le_re_bo">
                <div @click="goToTop">{{ $t("home.h24") }}</div>
                <div @click="toGaiyao">{{ $t("home.h25") }}</div>
                <div>{{ $t("home.h26") }}</div>
                <div @click="toshiji">{{ $t("home.h27") }}</div>
              </div>
            </div>
          </div>
          <div class="fo_re" @click="towenxun">{{ $t("home.h28") }}</div>
        </div>
        <div class="beian">{{ $t("home.h29") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  props: {
    msg: String,
  },
  data() {
    return {
      value1: 0,
      option1: [
        { text: "中文", value: 0 },
        { text: "日本語", value: 1 },
      ],
      selectedOption: "日本語",
    };
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    handleChange(event) {
      if (event.target.value == "日本語") {
        this.$i18n.locale = "ja";
      } else if (event.target.value == "中文") {
        this.$i18n.locale = "zh";
      }
    },
    toHome() {
      this.$router.push({ name: "HomePage" });
    },
    toGaiyao() {
      this.$router.push({ name: "GaiYao" });
    },
    tojieshao() {
      this.$router.push({ name: "JieShao" });
    },
    toshiji() {
      this.$router.push({ name: "ShiJi" });
    },
    towenxun() {
      this.$router.push({ name: "WenXun" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 700px) {
  .con_box,
  .top_box,
  .im_list,
  .foo_con,
  .wenan,
  .top_img {
    width: 100% !important;
  }
  .wenan {
    width: 90% !important;
  }
  .top_box,
  .img_box,
  .fo_le,
  .foo_con {
    flex-wrap: wrap;
    margin-bottom: 20px !important;
  }
  .top_img img {
    width: 100% !important;
  }
  .HomePage {
    padding: 0 !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .hudong_title {
    width: 40% !important;
    font-size: 16px !important;
    height: 40px !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
    font-size: 14px;
    margin: 0 auto;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .footer {
    padding-top: 0 !important;
  }
  .fo_le img {
    width: 100px !important;
    height: 100px !important;
  }
  .foo_con {
    flex-direction: column !important;
  }
  .fo_le {
    flex-direction: column !important;
    align-items: center !important;
    gap: 0 !important;
  }
  .fo_le_re_bo {
    margin-top: 20px !important;
  }
  .beian {
    margin-top: 0 !important;
  }
  .wenan {
    line-height: 30px !important;
    font-size: 16px !important;
  }
  .title2 {
    width: 90% !important;
    font-size: 19px !important;
  }
  .j1_img {
    width: 100% !important;
    margin-bottom: 20px !important;
  }
  .j2_img img {
    width: 100% !important;
    margin-bottom: 30px !important;
  }
  .span_te {
    display: block !important;
  }
  .hang1 {
    height: 16px;
  }
}
.hang {
  height: 16px;
}
.title2 {
  font-size: 24px;
  font-weight: 600;
  width: 75%;
  text-align: left;
  margin: 0 auto;
}
.j1_img {
  width: 100%;
  margin: 0px auto;
}
.j1_img img {
  width: 100%;
  margin-top: -17px;
}
.j2_img img {
  width: 90%;
  margin-bottom: 20px;
}
.wenan {
  line-height: 45px;
  margin-bottom: 20px;
  width: 75%;
  margin: 20px auto;
  text-align: left;
  font-size: 19px;
  /* color: #1e386b; */
}
.wenan1 {
  margin-bottom: 30px;
}
.hudong_title {
  width: 25%;
  height: 60px;
  font-size: 27px;
  border-radius: 30px;
  background-color: #1e386b;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.fo_le_re_bo div {
  cursor: pointer;
}
/* css */
.HomePage {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.con_box {
  width: 90%;
  margin: 0 auto;
}
.top_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_img {
  display: flex;
  gap: 0px;
  align-items: center;
}

.name_box {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: baseline;
}
.name_box :nth-child(1) {
  font-size: 22px;
  font-weight: 600;
}
.top_rig {
  display: flex;
  gap: 20px;
  align-items: center;
}
.tab1 {
  color: #1e386b;
  font-size: 20px;
  font-weight: 600;
}
.HomePage >>> .van-dropdown-menu__bar {
  width: 115px;
  height: 40px;
  /* box-shadow: none; */
}
.HomePage >>> .van-dropdown-item__content {
  /* right: 222px !important; */
  width: 116px;
}
.HomePage >>> .van-popup--top {
  right: 222px !important;
  left: auto;
}
.van-popup--top {
  right: 222px;
  left: auto;
}
.tab {
  cursor: pointer;
}
.footer {
  background-color: #153266;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.foo_con {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
}
.fo_le {
  display: flex;
  gap: 40px;
}
.fo_le img {
  width: 200px;
  height: 200px;
}
.fo_le_re {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
}
.fo_top {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}
.fo_le_re_bo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
}
.fo_re {
  color: #fff;
  cursor: pointer;
}
.beian {
  text-align: center;
  margin-top: 70px;
  /* margin-bottom: 10px; */
  color: #fff;
}
select {
  width: 100px;
  height: 40px;
  box-shadow: 1px 2px 3px #999;
  border: none;
  text-align: center;
  outline: none;
}
.bg_img {
  width: 100%;
}
.bg_img img {
  width: 100%;
}
</style>
